import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Alert,
  Link as MuiLink,
} from '@mui/material';
import { motion } from 'framer-motion';
import { Email, LinkedIn, GitHub, Twitter } from '@mui/icons-material';
import profileConfig from '../constants/profileConfig';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="sm">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Typography variant="h2" align="center" sx={{ mb: 2, fontWeight: 600 }}>
            Contact Me
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 4 }}>
            For collaborations, student inquiries, or just to say hello
          </Typography>
          {submitted && <Alert severity="success" sx={{ mb: 2 }}>Thank you! Your message has been sent.</Alert>}
          <Box component="form" onSubmit={handleSubmit} sx={{ mb: 4 }}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Message"
              name="message"
              value={form.message}
              onChange={handleChange}
              multiline
              rows={4}
              sx={{ mb: 2 }}
              required
            />
            <Button type="submit" variant="contained" size="large" fullWidth startIcon={<Email />}>Send Message</Button>
          </Box>
          <Typography variant="h6" align="center" sx={{ mb: 2 }}>
            Connect with me
          </Typography>
          <Grid container spacing={2} justifyContent="center">
            {profileConfig.socialLinks.linkedin && (
              <Grid item>
                <Button component={MuiLink} href={profileConfig.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" startIcon={<LinkedIn />} variant="outlined">
                  LinkedIn
                </Button>
              </Grid>
            )}
            {profileConfig.socialLinks.github && (
              <Grid item>
                <Button component={MuiLink} href={profileConfig.socialLinks.github} target="_blank" rel="noopener noreferrer" startIcon={<GitHub />} variant="outlined">
                  GitHub
                </Button>
              </Grid>
            )}
            {profileConfig.socialLinks.twitter && (
              <Grid item>
                <Button component={MuiLink} href={profileConfig.socialLinks.twitter} target="_blank" rel="noopener noreferrer" startIcon={<Twitter />} variant="outlined">
                  Twitter
                </Button>
              </Grid>
            )}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Contact; 